module.exports = __webpack_public_path__ + "img/rustore.740dfd05.jpg";